import { SVGProps } from "react";

export const SVGIconNewChat = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" fill="none" viewBox="0 0 17 18" {...props}>
    <path
      fill="#2B2A27"
      stroke="#2B2A27"
      strokeWidth="0.2"
      d="M5.823 7.27a.965.965 0 11-1.93 0 .965.965 0 011.93 0zm3.858 0a.965.965 0 11-1.93 0 .965.965 0 011.93 0zm3.858 0a.964.964 0 11-1.929 0 .964.964 0 011.93 0z"
    ></path>
    <path
      fill="#2B2A27"
      stroke="#2B2A27"
      strokeWidth="0.2"
      d="M13.54 1.965a1.931 1.931 0 011.928 1.929v6.752a1.93 1.93 0 01-1.929 1.929H8.317l-3.459 3.458v-3.458h-.964a1.931 1.931 0 01-1.93-1.93V3.894a1.931 1.931 0 011.93-1.93h9.645zm0-.965H3.893A2.894 2.894 0 001 3.894v6.752a2.894 2.894 0 002.894 2.893v2.495a.964.964 0 001.646.681l3.176-3.176h4.823a2.894 2.894 0 002.894-2.893V3.894A2.894 2.894 0 0013.539 1h0z"
    ></path>
  </svg>
);
